import { dmnIdentity } from "../../utils/dmnIdentity";
import { getEnvironmentProps } from "../../utils/environment";
import { errorHandler, throwApiError } from "../errorHandler";
import { PreorderMenu } from "../../types/VenueGroup";

export const fetchPreOrderMenus = async (
  venueId: string | undefined
): Promise<PreorderMenu[]> => {
  if (!venueId) {
    return [];
  }

  const token = await dmnIdentity.getAccessToken();
  const environmentVars = getEnvironmentProps(token);

  try {
    const response = await fetch(
      `${environmentVars?.CORE_API_BASE_URL}/venues/${venueId}/preorder-menus`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`
        }
      }
    );

    if (!response.ok) {
      await throwApiError(response, "Error fetching pre-order menus");
    }

    const data = await response.json();
    // Extract menus from payload.venue.preorder_menus
    const menus = data.payload?.venue?.preorder_menus || [];

    return menus;
  } catch (error) {
    errorHandler(error, "Error fetching pre-order menus");
    return [];
  }
};
